import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BaseComponent } from "../core/base.component";
import { UserData } from "../shared/models/user.model";
import { GlobalDataService } from "../shared/services/global-data.service";
import { SessionService } from "../shared/services/session.service";
import { AuthService } from "@auth0/auth0-angular";
import { GolfTechType } from "../shared/models/golftech-type.enum";
import { StringHelpers } from "../shared/helpers/string-helpers";
import { retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AccountService } from "../account/account.service";

@Component({
    selector: "post-login-layout",
    templateUrl: "./postLogin-layout.component.html",
    styleUrls: ["./layout.component.scss"],
    standalone: false
})
export class PostLoginLayoutComponent extends BaseComponent implements OnInit {
  public user: UserData = new UserData();
  public isSkeletonLoading: boolean;

  constructor(
    public sessionService: SessionService,
    private router: Router,
    private globalDataService: GlobalDataService,
    public authService: AuthService,
    private accountService: AccountService,
    stringHelpers: StringHelpers
  ) {
    super(sessionService, stringHelpers);
  }


  ngOnInit() {
    this.isLoading = true;
    this.isSkeletonLoading = true;
    if (!this.sessionService.isUserLoggedIn()) {
      this.authService.user$.subscribe(result => {
        this.accountService.getUserByAuth0Id(result.sub)
          .pipe(
            retry(5),
            catchError(error => {
              console.error('Failed to get user after 5 attempts:', error);
              this.isLoading = false;
              this.isSkeletonLoading = false;
              // Return empty observable to prevent subscription error
              return of(null);
            })
          )
          .subscribe({
            next: (user) => {
              if (user) {
                this.user = user;
                this.sessionService.setUser(this.user);
                this.globalDataService.postLoginEvent.emit();
                this.navigate();
              }
            },
            error: (err) => {
              this.isLoading = false;
              this.isSkeletonLoading = false;
              console.log(err);
            }
          });
      });
    } else {
      this.user = this.sessionService.getUser();
      this.navigate();
    }
  }

  navigate() {
    if (this.user.golfTechType === GolfTechType.Simulator) {
      this.router.navigate(['/simulator-management']);
      this.isSkeletonLoading = false;
    } else {
      this.router.navigate(['/outing-management']);
      this.isSkeletonLoading = false;
    }
  }
}
